import { isValidPhoneNumber } from "libphonenumber-js";

export const fieldValidators = {
  ninValid: (nin) => nin?.trim() === "" || (nin?.length === 11 && /^\d+$/.test(nin)),
  bvnValid: (bvn) => bvn?.trim() === "" || (bvn?.length === 11 && /^\d+$/.test(bvn)),
  phoneValid: (phone) => phone?.trim() === "" || (phone && isValidPhoneNumber(phone, "NG")),
  salaryValid: (salary) => (typeof salary === "string" ? salary?.trim() !== "" : !!salary) && !isNaN(salary) && Number(salary) >= 0,
  savingsValid: (savings) => (typeof savings === "string" ? savings?.trim() !== "": !!savings) && !isNaN(savings) && Number(savings) >= 0,
  accountNumberValid: (number) => number?.trim() !== "" && /^\d+$/.test(number) && number?.length === 10,
  textValid: (text) => text?.trim() !== "" && /^[a-zA-Z0-9\-\s]+$/.test(text),
  /* Makeup Length Validation for Text Fields */
  makeUpLenTextValid: (text, makeUp = { max: 5, min: 2 }) => fieldValidators.textValid(text) && text.length >= makeUp.min && text.length <= makeUp.max,
  nameValidTextValid: (text) => fieldValidators.makeUpLenTextValid(text, { max: 50, min: 2 }),
  /* valid helper text */
  ninHelperText: (nin) => {
    if (nin?.trim() === "") return "";
    if (nin?.length !== 11) return "NIN must be 11 digits";
    if (!/^\d+$/.test(nin)) return "NIN must contain only digits";
    return "";
  },
  textHelperText: (text) => {
    if (text?.trim() === "") return "";
    if (!/^[a-zA-Z0-9\s]+$/.test(text)) return "Text must be alphanumeric";
    return "";
  },
  bvnHelperText: (bvn) => {
    if (bvn?.trim() === "") return "";
    if (bvn?.length !== 11) return "BVN must be 11 digits";
    if (!/^\d+$/.test(bvn)) return "BVN must contain only digits";
    return "";
  },
  phoneHelperText: (phone) => {
    if (phone?.trim() === "") return "";
    if (phone && !isValidPhoneNumber(phone, "NG")) return "Enter a valid Nigerian phone number";
    return "";
  },
  salaryHelperText: (salary) => {
    if (!salary) return "Salary is required";
    if (typeof salary === "string" && salary?.trim() === "") return "";
    if (isNaN(salary) || Number(salary) < 0) return "Salary must be a non-negative number";
    return "";
  },
  savingsHelperText: (savings) => {
    if (!savings) return "Savings is required";
    if (typeof savings === "string" && savings?.trim() === "") return "";
    if (isNaN(savings) || Number(savings) < 0) return "Savings must be a non-negative number";
    return "";
  },
  accountNumberHelperText: (number) => {
    if (number?.trim() === "") return "";
    if (number?.length !== 10) return "Account number must be 10 digits";
    if (!/^\d+$/.test(number)) return "Account number must contain only digits";
    return "";
  },
  makeUpLenTextHelperText: (text, makeUp={max: 5, min: 2}) => {
    if (text?.trim() === "") return "";
    if (!/^[a-zA-Z0-9\s]+$/.test(text)) return "Text must be alphanumeric";
    if (text.length < makeUp.min || text.length > makeUp.max) return `Text must be between ${makeUp.min} and ${makeUp.max} characters`;
    return "";
  },
  nameValidTextHelperText: (text) => fieldValidators.makeUpLenTextHelperText(text, { max: 50, min: 2 }),
  /* Valid Input Check */
  validNINInput: (nin) => nin?.trim() === "" || /^\d*$/.test(nin),
  validBVNInput: (bvn) => bvn?.trim() === "" || /^\d*$/.test(bvn),
  validPhoneInput: (phone) => phone?.trim() === "" || /^\d*$/.test(phone),
  textInput: (text) => /^[a-zA-Z0-9\-\s]*$/.test(text),
  validSalaryInput: (salary) => (typeof salary === "string" ? salary?.trim() === "" : !!salary) || /^\d*\.?\d*$/.test(salary),
  validSavingsInput: (savings) => (typeof savings === "string" ? savings?.trim() === "" : !!savings) || /^\d*\.?\d*$/.test(savings),
  validAccountNumberInput: (number) => number?.trim() === "" || /^\d*$/.test(number) || number?.length === 10,
  validMakeUpLenTextInput: (text, makeUp = { max: 5, min: 2 }) => fieldValidators.textInput(text) && (text?.length <= makeUp.max || text?.length === 0),
  nameValidTextInput: (text) => fieldValidators.validMakeUpLenTextInput(text, { max: 50, min: 2 }),

}